/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssociationMembership } from '../models/AssociationMembership';
import type { CreateAssociationMembershipDto } from '../models/CreateAssociationMembershipDto';
import type { UpdateAssociationMembershipDto } from '../models/UpdateAssociationMembershipDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AssociationMembershipService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AssociationMembership
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody: CreateAssociationMembershipDto,
  }): CancelablePromise<AssociationMembership> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/association/{associationId}/membership',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns any[]
   * @throws ApiError
   */
  public find(): CancelablePromise<any[]> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/association/{associationId}/membership/{associationUserId}',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public updateById({
    id,
    requestBody,
    relations,
  }: {
    id: number,
    requestBody: UpdateAssociationMembershipDto,
    relations?: Array<string>,
  }): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/v1/association/{associationId}/membership/{id}',
      path: {
        'id': id,
        'relations': relations,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public deleteById({
    id,
    relations,
  }: {
    id: number,
    relations?: Array<string>,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/v1/association/{associationId}/membership/{id}',
      path: {
        'id': id,
        'relations': relations,
      },
    });
  }
}
